import Marquee from "react-fast-marquee";

const Diamond = () => (
    <svg width="9" height="9" viewBox="0 0 10 10" className="text-[#C8A45D] shrink-0" aria-hidden="true">
        <rect x="2" y="2" width="6" height="6" transform="rotate(45 5 5)" fill="none" stroke="currentColor" strokeWidth="1.4" />
    </svg>
);

export const EditorialMarquee = ({ items }) => (
    <div className="border-y border-white/10 bg-[#172337] py-6 overflow-hidden" data-testid="editorial-marquee">
        <Marquee speed={38} gradient={false} autoFill>
            {items.map((item, i) => (
                <span key={i} className="flex items-center gap-10 pr-10">
                    <span className="font-display italic text-xl sm:text-2xl text-[#E4D2A3] whitespace-nowrap">{item}</span>
                    <Diamond />
                </span>
            ))}
        </Marquee>
    </div>
);
